import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// In production builds we silence developer-facing console output (.log/.info/
// .warn/.error/.debug) so internal diagnostic messages don't leak to end users
// and don't degrade browser performance. Real errors still surface through
// React's error overlay (dev) and toast notifications / Sentry (prod). To
// re-enable temporarily, set window.__rmDebug = true in DevTools.
if (process.env.NODE_ENV === 'production') {
  ['log', 'info', 'warn', 'error', 'debug'].forEach((m) => {
    const orig = console[m];
    console[m] = (...args) => { if (window.__rmDebug) orig.apply(console, args); };
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
